import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../services/auth.service';

/**
 * Legacy compatibility entry for organization/edit and organization/edit/:pk.
 * Redirects to the Organization Profile child route without guessing an ID
 * when none is available.
 */
@Component({
    selector: 'app-edit-organization',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="main-content" data-testid="organization-edit-redirect">
            <p>Opening organization profile…</p>
        </div>
    `,
})
export class EditOrganizationComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private auth: AuthService,
        private toastr: ToastrService,
    ) {
    }

    ngOnInit(): void {
        const pk = this.route.snapshot.paramMap.get('pk');
        if (pk) {
            this.navigateToProfile(pk, 'customer');
            return;
        }

        const userInfo = this.auth.getCurrentUserInfo();
        const orgId = userInfo?.orgId;
        if (orgId !== null && orgId !== undefined && `${orgId}`.trim() !== '') {
            this.navigateToProfile(String(orgId), 'organization');
            return;
        }

        this.toastr.error('Unable to determine which organization to open.', 'Error');
        this.router.navigate(['/organization'], {replaceUrl: true});
    }

    private navigateToProfile(
        organizationId: string,
        listTab: 'customer' | 'organization',
    ): void {
        const queryParams = listTab === 'organization'
            ? {returnTab: 'organization'}
            : {returnTab: null};
        this.router.navigate(
            ['/organization', organizationId, 'profile'],
            {
                replaceUrl: true,
                queryParams,
                queryParamsHandling: 'merge',
                fragment: this.route.snapshot.fragment || undefined,
            },
        );
    }
}
